import React, { useState, useEffect } from "react";

import styles from "./index.module.css";
import ReportTableQualifiedGroupOverview from "Reporting/Components/ReportTableQualifiedGroupOverview";
import { useQualifiedGroupOverviewGet } from "./useQualifiedGroupOverviewGet";
import Loader from "shared/Loader";

export default function ReportTableListQualifiedGroupOverview({
  filters,
  setReportsLength,
  setReportData,
  fetchTrigger,
}) {
  const [reports, setReports] = useState([]);
  const [sortedReportsByTitle, setSortedReportsByTitle] = useState({});

  const { data, isLoading, isError, refetch } = useQualifiedGroupOverviewGet({
    events: filters.events,
  });

  useEffect(() => {
    if (typeof fetchTrigger !== "undefined") {
      refetch?.();
    }
  }, [fetchTrigger]);

  useEffect(() => {
    if (data) {
      setReports(data);
      setReportsLength?.(data.length || 0);

      setSortedReportsByTitle(() => {
        const updated = {};
        data.forEach((report) => {
          updated[report.reportTitle] = report;
        });
        return updated;
      });
    }
  }, [data, setReportsLength]);

  // Handle child sorted/filtered updates
  const handleSortedReportsChange = (title, sorted) => {
    setSortedReportsByTitle((prev) => ({ ...prev, [title]: sorted }));
  };

  // Rebuild reportData for PDF with sorted/filtered rows when available
  useEffect(() => {
    if (reports.length === 0) return;

    const merged = reports.map((report) =>
      sortedReportsByTitle[report.reportTitle]
        ? sortedReportsByTitle[report.reportTitle]
        : report
    );

    setReportData?.(merged);
  }, [sortedReportsByTitle, reports, setReportData]);

  if (isError) {
    return <div>Something went wrong...</div>;
  }
  if (isLoading) {
    return <Loader />;
  }

  if (reports.length === 0) {
    return <div>No Reports Found</div>;
  }

  return (
    <div className={styles.container}>
      {reports.map((report, index) => (
        <React.Fragment key={index}>
          <ReportTableQualifiedGroupOverview
            report={report}
            title={report.reportTitle}
            onSortedReportsChange={handleSortedReportsChange}
          />
        </React.Fragment>
      ))}
    </div>
  );
}
